import React from "react";
import { Button } from "react-bootstrap";
export const AddButton = ({ formName, handleAddBtn }) => {

  const handleShow = () => handleAddBtn(true);

    return(
        <React.Fragment>
           <div className="Add-Item">
            <Button className="add-btn" onClick={() => handleShow()} >Add {formName}</Button>
           </div>
        </React.Fragment>
    )
}